<template>
    <div class="alert-details-page p-3">
        <component-header
            title="Transaction Details"
            :hasSearch="false"
            :hasCreate="false"
            :hasReload="false"
            :hasback="true"
            @back-press="goBack"
        />
        <b-row>
            <b-col cols="12" lg="9" class="mb-3 mb-lg-0">
                <b-card class="mb-3">
                    <!-- User Profile Section -->
                    <div class="section mb-4">
                        <h5 class="section-title mb-3">User Profile</h5>
                        <b-row>
                            <b-col cols="12" sm="6" class="mb-3 mb-sm-0">
                                <div class="info-item mb-3">
                                    <label class="info-label">Name:</label>
                                    <span class="info-value">{{
                                        alertData?.user ||
                                        alertData?.item?.customer_name ||
                                        "N/A"
                                    }}</span>
                                </div>
                                <div class="info-item mb-3">
                                    <label class="info-label">Email:</label>
                                    <span class="info-value">{{
                                        alertData?.item?.customer_email || "N/A"
                                    }}</span>
                                </div>
                                <div class="info-item mb-3">
                                    <label class="info-label">Phone:</label>
                                    <span class="info-value">{{
                                        alertData?.item?.customer_phone || "N/A"
                                    }}</span>
                                </div>
                                <div class="info-item mb-3">
                                    <label class="info-label"
                                        >Alert Type:</label
                                    >
                                    <span class="info-value">{{
                                        alertData?.type ||
                                        alertData?.item?.reason ||
                                        "N/A"
                                    }}</span>
                                </div>
                            </b-col>
                            <b-col cols="12" sm="6">
                                <div class="info-item mb-3">
                                    <label class="info-label"
                                        >Account Age:</label
                                    >
                                    <span class="info-value">3 months</span>
                                </div>
                                <div class="info-item mb-3">
                                    <label class="info-label"
                                        >Past Behavior Rating:</label
                                    >
                                    <div class="mt-2">
                                        <b-progress
                                            :value="45"
                                            :max="100"
                                            class="behavior-progress"
                                        ></b-progress>
                                    </div>
                                </div>
                                <div class="info-item mb-3">
                                    <label class="info-label"
                                        >Total Orders:</label
                                    >
                                    <span class="info-value">8 orders</span>
                                </div>
                            </b-col>
                        </b-row>
                    </div>

                    <!-- Transaction Summary Section -->
                    <div class="section mb-4">
                        <h5 class="section-title mb-3">Transaction Summary</h5>
                        <b-row>
                            <b-col cols="12" sm="6" class="mb-3 mb-sm-0">
                                <div class="info-item mb-3">
                                    <label class="info-label">Amount:</label>
                                    <span class="info-value font-weight-bold">
                                        {{
                                            alertData?.item?.orderamount
                                                ? `$${parseFloat(alertData.item.orderamount).toFixed(2)}`
                                                : "N/A"
                                        }}
                                    </span>
                                </div>
                                <div class="info-item mb-3">
                                    <label class="info-label"
                                        >Order Status:</label
                                    >
                                    <span class="info-value">{{
                                        alertData?.item?.orderstatus ||
                                        alertData?.orderstatus ||
                                        "N/A"
                                    }}</span>
                                </div>
                                <div class="info-item mb-3">
                                    <label class="info-label"
                                        >Alert Status:</label
                                    >
                                    <span class="info-value">{{
                                        alertData?.status ||
                                        alertData?.item?.event_status ||
                                        "N/A"
                                    }}</span>
                                </div>
                                <div class="info-item mb-3">
                                    <label class="info-label"
                                        >Event Type:</label
                                    >
                                    <span class="info-value">{{
                                        alertData?.item?.event_type || "N/A"
                                    }}</span>
                                </div>
                            </b-col>
                            <b-col cols="12" sm="6">
                                <div class="info-item mb-3">
                                    <label class="info-label"
                                        >Alert Time:</label
                                    >
                                    <span class="info-value">{{
                                        alertData?.time || "N/A"
                                    }}</span>
                                </div>
                                <div class="info-item mb-3">
                                    <label class="info-label"
                                        >Created At:</label
                                    >
                                    <span class="info-value">
                                        {{
                                            alertData?.item?.createdat
                                                ? new Date(
                                                      alertData.item.createdat,
                                                  ).toLocaleString()
                                                : alertData?.createdat
                                                  ? new Date(
                                                        alertData.createdat,
                                                    ).toLocaleString()
                                                  : "N/A"
                                        }}
                                    </span>
                                </div>
                                <div class="info-item mb-3">
                                    <label class="info-label"
                                        >Customer ID:</label
                                    >
                                    <span class="info-value">{{
                                        alertData?.item?.customer_id || "N/A"
                                    }}</span>
                                </div>
                            </b-col>
                        </b-row>
                    </div>

                    <!-- AI Analysis Section -->
                    <div class="section mb-4">
                        <h5 class="section-title mb-3">AI Analysis</h5>

                        <div class="mb-4">
                            <div class="d-flex justify-content-between mb-2">
                                <label class="info-label">Risk Score:</label>
                                <span
                                    class="font-weight-bold"
                                    :class="getRiskColorClass()"
                                >
                                    {{ getRiskScore() }}/100
                                </span>
                            </div>
                            <b-progress
                                :value="getRiskScore()"
                                :max="100"
                                :variant="getRiskVariant()"
                                class="risk-progress"
                            ></b-progress>
                        </div>

                        <div class="mb-4">
                            <h6 class="mb-3">Reasons Flagged:</h6>
                            <div class="flagged-reasons">
                                <div
                                    class="reason-item mb-2"
                                    v-for="reason in flaggedReasons"
                                    :key="reason"
                                >
                                    <i
                                        class="fa fa-exclamation-triangle text-danger mr-2"
                                    ></i>
                                    <span>{{ reason }}</span>
                                </div>
                            </div>
                        </div>

                        <div>
                            <h6 class="mb-3">Historical Patterns:</h6>
                            <div class="historical-patterns">
                                <div class="pattern-item pattern-red mb-2">
                                    <i class="fa fa-history mr-2"></i>
                                    <span
                                        >2 previous chargebacks in the last 2
                                        months</span
                                    >
                                </div>
                                <div class="pattern-item pattern-orange mb-2">
                                    <i class="fa fa-globe mr-2"></i>
                                    <span
                                        >Account accessed from 5 different
                                        countries in past month</span
                                    >
                                </div>
                                <div class="pattern-item pattern-orange mb-2">
                                    <i class="fa fa-bolt mr-2"></i>
                                    <span
                                        >Rapid purchase pattern: 3 high-value
                                        orders in 24 hours</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Evidence Section -->
                    <div class="section">
                        <h5 class="section-title mb-3">Evidence</h5>

                        <!-- Weight Comparison -->
                        <div class="mb-4">
                            <h6 class="mb-3">Weight Comparison</h6>
                            <div class="weight-chart-container">
                                <div class="weight-bar-wrapper mb-3">
                                    <div class="weight-label">Original</div>
                                    <div class="weight-bar-container">
                                        <div
                                            class="weight-bar weight-bar-green weight-bar-full"
                                        >
                                            <span class="weight-value"
                                                >2.6 kg</span
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div class="weight-bar-wrapper">
                                    <div class="weight-label">Return</div>
                                    <div class="weight-bar-container">
                                        <div
                                            class="weight-bar weight-bar-red weight-bar-half"
                                        >
                                            <span class="weight-value"
                                                >1.3 kg</span
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="alert alert-danger mt-3 mb-0">
                                <i class="fa fa-exclamation-circle mr-2"></i>
                                Alert: Return package is 52% lighter than
                                original shipment
                            </div>
                        </div>

                        <!-- Return Photos -->
                        <div
                            class="mb-4"
                            v-if="
                                alertData?.item?.return_photos &&
                                alertData?.item?.return_photos.length > 0
                            "
                        >
                            <h6 class="mb-3">Return Photos</h6>
                            <b-row>
                                <b-col
                                    cols="12"
                                    sm="6"
                                    class="mb-3 mb-sm-0"
                                >
                                    <div class="photo-placeholder">
                                        <i
                                            class="fa fa-box fa-3x text-muted mb-2"
                                        ></i>
                                        <p class="text-muted mb-0">
                                            Before (Original)
                                        </p>
                                    </div>
                                </b-col>
                                <b-col cols="12" sm="6">
                                    <div class="photo-placeholder">
                                        <i
                                            class="fa fa-box fa-3x text-muted mb-2"
                                        ></i>
                                        <p class="text-muted mb-0">
                                            After (Return)
                                        </p>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>

                        <!-- Barcode Comparison -->
                        <div>
                            <h6 class="mb-3">
                                Barcode / Serial Number Comparison
                            </h6>
                            <div class="barcode-comparison">
                                <div class="info-item mb-2">
                                    <label class="info-label"
                                        >Original Serial:</label
                                    >
                                    <span class="info-value"
                                        >SN-8972634ABC</span
                                    >
                                </div>
                                <div class="info-item mb-3">
                                    <label class="info-label"
                                        >Return Serial:</label
                                    >
                                    <span class="info-value"
                                        >SN-1234567XYZ</span
                                    >
                                </div>
                                <div class="alert alert-danger mb-0">
                                    <i
                                        class="fa fa-exclamation-circle mr-2"
                                    ></i>
                                    Alert: Serial numbers do not match -
                                    possible item swap fraud
                                </div>
                            </div>
                        </div>
                    </div>
                </b-card>
            </b-col>

            <!-- Right Action Panel -->
            <b-col cols="12" lg="3" class="mt-3 mt-lg-0">
                <b-card class="action-panel">
                    <h5 class="mb-4">Actions</h5>

                    <div class="action-buttons">
                        <b-button
                            variant="danger"
                            block
                            class="mb-2 action-btn"
                            @click="handleAction('markFraud')"
                        >
                            <i class="fa fa-times mr-2"></i> Mark as Fraud
                        </b-button>

                        <b-button
                            variant="success"
                            block
                            class="mb-2 action-btn"
                            @click="handleAction('approveReturn')"
                        >
                            <i class="fa fa-check mr-2"></i> Approve Return
                        </b-button>

                        <b-button
                            variant="dark"
                            block
                            class="mb-2 action-btn"
                            @click="handleAction('blockUser')"
                        >
                            <i class="fa fa-ban mr-2"></i> Block User
                        </b-button>

                        <b-button
                            variant="primary"
                            block
                            class="mb-2 action-btn"
                            @click="handleAction('refundCustomer')"
                        >
                            <i class="fa fa-dollar-sign mr-2"></i> Refund
                            Customer
                        </b-button>

                        <b-button
                            variant="info"
                            block
                            class="mb-2 action-btn"
                            @click="handleAction('assignInvestigator')"
                        >
                            <i class="fa fa-user mr-2"></i> Assign Investigator
                        </b-button>
                    </div>

                    <hr class="my-4" />

                    <div class="case-notes">
                        <h5 class="mb-3">Case Notes</h5>
                        <b-form-textarea
                            v-model="caseNotes"
                            placeholder="Add investigation notes..."
                            rows="6"
                            class="mb-3"
                        ></b-form-textarea>
                        <b-button variant="primary" block @click="saveNotes">
                            Save Notes
                        </b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader";

export default {
    name: "AlertDetails",
    components: {
        ComponentHeader,
    },
    data() {
        return {
            alertData: null,
            caseNotes: "",
            flaggedReasons: [],
        };
    },
    mounted() {
        const alertId = this.$route?.params?.id;

        // 1. Try router state first
        const stateAlert = this.$route?.state?.alertData;
        if (stateAlert && typeof stateAlert === "object") {
            this.assignAlertData(stateAlert);
            return;
        }

        // 2. Try sessionStorage
        const storedAlert = sessionStorage.getItem("alertData");
        if (storedAlert) {
            try {
                const parsedAlert = JSON.parse(storedAlert);
                if (parsedAlert && typeof parsedAlert === "object") {
                    this.assignAlertData(parsedAlert);
                    return;
                }
            } catch (error) {
                console.warn("Invalid alertData in sessionStorage", error);
            }
        }

        // 3. Final fallback – fetch by ID
        if (alertId) {
            this.fetchAlertById(alertId);
        } else {
            console.error("Alert ID not found in route params");
        }
    },

    beforeDestroy() {
        // Clean up sessionStorage when leaving the page
        sessionStorage.removeItem("alertData");
    },
    methods: {
        fetchAlertById(alertId) {
            // Try to find alert in store
            const alertList =
                this.$store.state.fraudManagement?.fraudAlertList?.data
                    ?.result || [];
            const foundAlert = alertList.find(
                (item) => `ALT-${item.id}` === alertId,
            );
            if (foundAlert) {
                // Transform the alert data similar to Dashboard
                this.alertData = this.transformAlertData(foundAlert);
                this.setFlaggedReasons();
            } else {
                // If not found, show default data
                this.alertData = {
                    id: alertId,
                    user: "N/A",
                    type: "N/A",
                    risk: "Medium",
                    time: "N/A",
                    status: "N/A",
                };
            }
        },
        transformAlertData(item) {
            const formatRelativeTime = (dateString) => {
                if (!dateString) return "N/A";
                const date = new Date(dateString);
                const now = new Date();
                const diffMs = now - date;
                const diffMins = Math.floor(diffMs / 60000);
                const diffHours = Math.floor(diffMs / 3600000);
                const diffDays = Math.floor(diffMs / 86400000);

                if (diffMins < 1) return "Just now";
                if (diffMins < 60) return `${diffMins} min ago`;
                if (diffHours < 24)
                    return `${diffHours} hour${diffHours > 1 ? "s" : ""} ago`;
                if (diffDays < 7)
                    return `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
                return date.toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    year:
                        date.getFullYear() !== now.getFullYear()
                            ? "numeric"
                            : undefined,
                });
            };

            const getStatus = (orderStatus, eventStatus) => {
                if (orderStatus === "refund") return "Closed";
                if (eventStatus === "ABUSE") return "Investigating";
                return "Open";
            };

            const formatType = (reason, eventStatus) => {
                if (reason) {
                    return reason
                        .replace(/_/g, " ")
                        .replace(/\b\w/g, (l) => l.toUpperCase());
                }
                if (eventStatus) {
                    return eventStatus
                        .replace(/_/g, " ")
                        .replace(/\b\w/g, (l) => l.toUpperCase());
                }
                return "Fraud Alert";
            };

            const isHashLike = (str) => {
                if (!str || typeof str !== "string") return false;
                return (
                    str.length >= 32 &&
                    /^[a-f0-9]+$/i.test(str) &&
                    !str.includes(" ")
                );
            };

            const getUserName = () => {
                const customerName = item.customer_name;
                if (customerName && !isHashLike(customerName)) {
                    return customerName;
                }
                return "N/A";
            };

            return {
                id: `ALT-${item.id}`,
                user: getUserName(),
                type: formatType(item.reason, item.event_status),
                risk: item.risk || "Medium",
                time: formatRelativeTime(item.createdat),
                status: getStatus(item.orderstatus, item.event_status),
                item: item, // Include the raw item data
            };
        },
        setFlaggedReasons() {
            if (!this.alertData || !this.alertData.item) {
                this.flaggedReasons = [];
                return;
            }
            const item = this.alertData.item;
            const reasons = [];
            if (item.reason) {
                reasons.push(
                    item.reason
                        .replace(/_/g, " ")
                        .replace(/\b\w/g, (l) => l.toUpperCase()),
                );
            }
            if (item.orderamount && parseFloat(item.orderamount) > 1000) {
                reasons.push("High-value transaction detected");
            }
            if (item.risk === "High" || item.risk === "Critical") {
                reasons.push(`High risk level: ${item.risk}`);
            }
            if (item.event_status === "ABUSE") {
                reasons.push("Abuse pattern detected");
            }
            if (item.behavior_fraud) {
                reasons.push("Behavioral fraud pattern detected");
            }
            if (item.fraud_source) {
                reasons.push(`Fraud source: ${item.fraud_source}`);
            }
            this.flaggedReasons =
                reasons.length > 0
                    ? reasons
                    : ["Fraud alert detected", "Requires investigation"];
        },
        getRiskScore() {
            if (!this.alertData || !this.alertData.item) return 50;
            const risk =
                this.alertData.item.risk?.toLowerCase() ||
                this.alertData.risk?.toLowerCase() ||
                "medium";
            if (risk === "critical") return 95;
            if (risk === "high") return 85;
            if (risk === "medium") return 60;
            return 30;
        },
        getRiskVariant() {
            if (!this.alertData || !this.alertData.item) return "warning";
            const risk =
                this.alertData.item.risk?.toLowerCase() ||
                this.alertData.risk?.toLowerCase() ||
                "medium";
            if (risk === "critical" || risk === "high") return "danger";
            if (risk === "medium") return "warning";
            return "success";
        },
        getRiskColorClass() {
            if (!this.alertData || !this.alertData.item) return "text-warning";
            const risk =
                this.alertData.item.risk?.toLowerCase() ||
                this.alertData.risk?.toLowerCase() ||
                "medium";
            if (risk === "critical" || risk === "high") return "text-danger";
            if (risk === "medium") return "text-warning";
            return "text-success";
        },
        goBack() {
            this.$router.go(-1);
        },
        handleAction(action) {
            this.$swal({
                title: "Action",
                text: `Action "${action}" triggered`,
                icon: "info",
                confirmButtonText: "OK",
            });
        },
        saveNotes() {
            this.$swal({
                title: "Success",
                text: "Case notes saved successfully",
                icon: "success",
                confirmButtonText: "OK",
            });
        },
    },
};
</script>

<style scoped>
/* ===== Base / Desktop styles ===== */
.alert-details-page {
    background-color: #f5f5f5;
    min-height: 100vh;
}

.section {
    padding-bottom: 1.5rem;
    border-bottom: 1px solid #e5e7eb;
}

.section:last-child {
    border-bottom: none;
}

.section-title {
    font-weight: 600;
    color: #1f2937;
    font-size: 18px;
}

.info-item {
    display: flex;
    flex-direction: column;
}

.info-label {
    font-size: 13px;
    color: #6b7280;
    font-weight: 500;
    margin-bottom: 4px;
}

.info-value {
    font-size: 15px;
    color: #1f2937;
    word-break: break-word;
}

.behavior-progress {
    height: 8px;
}

.risk-progress {
    height: 12px;
}

.flagged-reasons {
    padding-left: 0;
}

.reason-item {
    display: flex;
    align-items: flex-start;
    padding: 8px 12px;
    background-color: #fef2f2;
    border-left: 3px solid #ef4444;
    border-radius: 4px;
}

.historical-patterns {
    padding-left: 0;
}

.pattern-item {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    border-radius: 6px;
}

.pattern-red {
    background-color: #fee2e2;
    color: #991b1b;
}

.pattern-orange {
    background-color: #fed7aa;
    color: #9a3412;
}

.weight-chart-container {
    background-color: #f9fafb;
    padding: 20px;
    border-radius: 8px;
}

.weight-bar-wrapper {
    display: flex;
    align-items: center;
    gap: 15px;
}

.weight-label {
    min-width: 80px;
    font-weight: 500;
    color: #374151;
}

.weight-bar-container {
    flex: 1;
    background-color: #e5e7eb;
    border-radius: 4px;
    height: 40px;
    position: relative;
    overflow: hidden;
}

.weight-bar {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
    border-radius: 4px;
    transition: width 0.3s ease;
}

.weight-bar-green {
    background-color: #10b981;
}

.weight-bar-red {
    background-color: #ef4444;
}

.weight-value {
    color: white;
    font-weight: 600;
    font-size: 14px;
}

.photo-placeholder {
    border: 2px dashed #d1d5db;
    border-radius: 8px;
    padding: 40px 20px;
    text-align: center;
    background-color: #f9fafb;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.action-panel {
    position: sticky;
    top: 20px;
}

.action-buttons {
    display: flex;
    flex-direction: column;
}

.action-btn {
    font-weight: 500;
    padding: 10px;
}

.case-notes textarea {
    resize: none;
}

.barcode-comparison {
    background-color: #f9fafb;
    padding: 15px;
    border-radius: 6px;
}

.card {
    border: none;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.alert {
    border-radius: 6px;
    font-size: 14px;
}

.alert-danger {
    background-color: #fee2e2;
    border-color: #fecaca;
    color: #991b1b;
}

.weight-bar-full {
    width: 100%;
}

.weight-bar-half {
    width: 50%;
}

/* ===== Extra-large desktops (>= 1400px) ===== */
@media (min-width: 1400px) {
    .alert-details-page {
        max-width: 1600px;
        margin: 0 auto;
    }

    .section-title {
        font-size: 20px;
    }

    .info-value {
        font-size: 16px;
    }

    .weight-bar-container {
        height: 44px;
    }
}

/* ===== Large desktops (1200px – 1399px) ===== */
@media (min-width: 1200px) and (max-width: 1399.98px) {
    .section-title {
        font-size: 18px;
    }
}

/* ===== Standard desktops / large tablets landscape (992px – 1199px) ===== */
@media (min-width: 992px) and (max-width: 1199.98px) {
    .section-title {
        font-size: 17px;
    }

    .info-label {
        font-size: 12px;
    }

    .info-value {
        font-size: 14px;
    }

    .action-btn {
        padding: 8px;
        font-size: 13px;
    }

    .weight-chart-container {
        padding: 15px;
    }

    .weight-label {
        min-width: 65px;
        font-size: 13px;
    }

    .weight-bar-container {
        height: 34px;
    }

    .weight-value {
        font-size: 12px;
    }

    .photo-placeholder {
        min-height: 160px;
        padding: 25px 15px;
    }
}

/* ===== Tablets portrait (768px – 991px) ===== */
@media (min-width: 768px) and (max-width: 991.98px) {
    .alert-details-page {
        padding: 1rem !important;
    }

    .section-title {
        font-size: 17px;
    }

    .action-panel {
        position: static;
    }

    .action-buttons {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 6px;
    }

    .action-buttons .action-btn {
        flex: 1 1 calc(50% - 0.5rem);
        min-width: 0;
    }

    .case-notes {
        margin-top: 0.5rem;
    }

    .photo-placeholder {
        min-height: 180px;
        padding: 30px 15px;
    }

    .weight-chart-container {
        padding: 16px;
    }

    .barcode-comparison {
        padding: 12px;
    }
}

/* ===== Small tablets / large phones (576px – 767px) ===== */
@media (min-width: 576px) and (max-width: 767.98px) {
    .alert-details-page {
        padding: 0.75rem !important;
    }

    .section-title {
        font-size: 16px;
    }

    .info-label {
        font-size: 12px;
    }

    .info-value {
        font-size: 14px;
    }

    .action-panel {
        position: static;
    }

    .action-buttons {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 6px;
    }

    .action-buttons .action-btn {
        flex: 1 1 calc(50% - 0.5rem);
        min-width: 0;
        font-size: 13px;
        padding: 8px;
    }

    .weight-chart-container {
        padding: 14px;
    }

    .weight-label {
        min-width: 65px;
        font-size: 13px;
    }

    .weight-bar-container {
        height: 34px;
    }

    .weight-value {
        font-size: 12px;
    }

    .photo-placeholder {
        min-height: 150px;
        padding: 25px 12px;
    }

    .barcode-comparison {
        padding: 12px;
    }

    .reason-item {
        padding: 6px 10px;
        font-size: 13px;
    }

    .pattern-item {
        padding: 8px 10px;
        font-size: 13px;
    }
}

/* ===== Mobile phones (< 576px) ===== */
@media (max-width: 575.98px) {
    .alert-details-page {
        padding: 0.5rem !important;
    }

    .section {
        padding-bottom: 1rem;
    }

    .section-title {
        font-size: 15px;
        margin-bottom: 0.5rem !important;
    }

    .info-label {
        font-size: 12px;
    }

    .info-value {
        font-size: 13px;
    }

    .action-panel {
        position: static;
    }

    .action-buttons {
        flex-direction: column;
    }

    .action-btn {
        font-size: 13px;
        padding: 8px;
    }

    .weight-chart-container {
        padding: 12px;
    }

    .weight-bar-wrapper {
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
    }

    .weight-label {
        min-width: unset;
        font-size: 13px;
    }

    .weight-bar-container {
        width: 100%;
        height: 32px;
    }

    .weight-value {
        font-size: 11px;
    }

    .photo-placeholder {
        min-height: 120px;
        padding: 20px 10px;
    }

    .photo-placeholder .fa-3x {
        font-size: 2em !important;
    }

    .barcode-comparison {
        padding: 10px;
    }

    .reason-item {
        padding: 6px 8px;
        font-size: 12px;
    }

    .pattern-item {
        padding: 8px 10px;
        font-size: 12px;
    }

    .alert {
        font-size: 12px;
        padding: 8px 10px;
    }

    .risk-progress {
        height: 10px;
    }

    .card {
        border-radius: 8px;
    }
}
</style>
